import { useCallback, useEffect, useState } from "react";
import { History } from "lucide-react";
import { api, fmtRp, fmtNum } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

const ALL = "all";
const fmtAt = (iso) => new Date(iso).toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

export function CostHistoryTab() {
  const [batch, setBatch] = useState("");
  const [by, setBy] = useState(ALL);
  const [data, setData] = useState({ rows: [], operators: [] });
  const load = useCallback(() => api.get("/inventory/cost-history", { params: { ...(batch && { batch }), ...(by !== ALL && { by }) } }).then((r) => setData(r.data)), [batch, by]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);
  const [opsAll, setOpsAll] = useState([]);
  useEffect(() => { api.get("/inventory/cost-history").then((r) => setOpsAll(r.data.operators)); }, []);

  return (
    <div data-testid="cost-history-tab">
      <div className="card-aqua p-4 mb-4 flex flex-wrap items-center gap-3 rise rise-1">
        <Input value={batch} onChange={(e) => setBatch(e.target.value)} placeholder="Cari kode batch..." className="w-56" data-testid="input-history-batch" />
        <Select value={by} onValueChange={setBy}><SelectTrigger className="w-56" data-testid="select-history-operator"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value={ALL}>Semua operator</SelectItem>{opsAll.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}</SelectContent></Select>
        <span className="text-sm text-slate-500 ml-auto" data-testid="history-count">{data.rows.length} koreksi</span>
      </div>
      <div className="card-aqua overflow-hidden rise rise-2">
        <table className="w-full text-sm" data-testid="table-cost-history">
          <thead className="table-head"><tr>{["Waktu", "Kode Batch", "Jenis / Size", "Harga Lama", "Harga Baru", "Selisih", "Alasan", "Operator"].map((h) => <th key={h} className={`px-4 py-3 ${["Harga Lama", "Harga Baru", "Selisih"].includes(h) ? "text-right" : "text-left"}`}>{h}</th>)}</tr></thead>
          <tbody>
            {data.rows.length === 0 && <tr><td colSpan={8} className="text-center py-12 text-slate-500" data-testid="history-empty"><History className="h-5 w-5 mx-auto mb-2 text-slate-300" />Belum ada koreksi harga.</td></tr>}
            {data.rows.map((r, i) => (
              <tr key={`${r.inventory_id}-${r.at}`} className="border-t border-sky-50 hover:bg-sky-50/50" data-testid={`history-row-${i}`}>
                <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{fmtAt(r.at)}</td>
                <td className="px-4 py-3 font-mono text-xs font-semibold text-sky-800">{r.batch_code}</td>
                <td className="px-4 py-3 text-slate-700">{r.species_name} <span className="text-slate-400">{r.size}</span> <span className="text-[10px] text-slate-400">• stok {fmtNum(r.quantity_mc)} {r.unit}</span></td>
                <td className="px-4 py-3 text-right font-mono text-slate-500">{r.old_cost ? fmtRp(r.old_cost) : "—"}</td>
                <td className="px-4 py-3 text-right font-mono font-semibold text-slate-900">{fmtRp(r.new_cost)}</td>
                <td className={`px-4 py-3 text-right font-mono font-semibold ${r.diff > 0 ? "text-rose-600" : r.diff < 0 ? "text-emerald-700" : "text-slate-400"}`}>{r.diff > 0 ? "+" : ""}{fmtRp(r.diff)}</td>
                <td className="px-4 py-3 text-slate-600 max-w-[260px] truncate" title={r.reason}>{r.reason}</td>
                <td className="px-4 py-3 text-slate-600">{r.by}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
